import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  static maxTextLengthValidator(maxLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value || '';
      const plainText = value.replace(/<[^>]*>/g, '').trim();

      if (plainText.length > maxLength) {
        return {
          maxTextLength: {
            actualLength: plainText.length,
            requiredLength: maxLength,
          }
        };
      }

      return null;
    };
  }
}
